class VideoText extends HTMLElement {
  constructor() {
    super();

  }

  connectedCallback() {
    const video = this.querySelector('video');
    const playButton = this.querySelector('.video-text__button-play');
    const stopButton = this.querySelector('.video-text__button-stop');
    const soundButton = this.querySelector('.video-text__button-sound');
    const img = this.querySelector('.video-text__content-img img');

    if (stopButton) {
      stopButton.style.display = 'none';
    }

    if (playButton) {
      playButton.addEventListener("click", () => {
        if (video) {
          img.style.display = 'none';
          video.play().catch(err => console.error('Erreur en jouant la vidéo:', err));
      
          playButton.style.display = 'none';
          if (stopButton){
            stopButton.style.display = 'flex';
          } 
            
        }
      });
    }

    if (stopButton) {
      stopButton.addEventListener("click", () => {
        if (video) {
          video.pause();
          stopButton.style.display = 'none';
          if (playButton){ 
            playButton.style.display = 'flex';
          }
        }
      });
    }

    if (soundButton) {
      soundButton.addEventListener("click", () => {
        if (video) {
          video.muted = !video.muted; 
          soundButton.classList.toggle('muted', video.muted);
        }
      });
    }
  }

}

customElements.define('video-text', VideoText);
